
const dataCacheMap = {};
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'

@Component({})
export default class extends Vue {
  @Prop()
  modelValue: any;

  @Prop()
  mode: any;

  @Prop({
    default() {
      return 'common'
    }
  })
  type: string;

  get showName() {
    return this.show.name;
  }

  get linkEvent() {
    return this.modelValue && this.modelValue.event;
  }

  // 之前填进去的值，行内只显示选项名，鼠标经过才把这个带出来
  get showText() {
    let event = this.linkEvent;
    if (!event) return this.showName;
    if (typeof event == 'object') {
      // 其他小程序存的是 { appid, page }
      return `${this.showName}：${[event.appid, event.page].filter(Boolean).join(' ')}`;
    }
    return `${this.showName}：${event}`;
  }

  get loginCheck() {
    return !!(this.modelValue && this.modelValue.login == 1);
  }

  @Watch('request')
  async requestWatch() {
    this.show = await (async () => {
      if (!this.modelValue || !this.modelValue.type) return;
      let res = this.getSelect(this.modelValue);
      return res;
    })();
  }


  list: any[] = []
  key = 0
  show = null

  // 回显当前选中项，重新打开级联时能看出选的是哪一条
  get value_() {
    let { type, value } = this.modelValue || {};
    if (!type) return [];
    // 在线客服、返回顶部这类顶层就是叶子节点，只有 type
    return value ? [type, value] : [type];
  }
  get request() {
    const { modelValue, list } = this;
    return { modelValue, list };
  }

  created() {
    this.getDropList();
  }

  async getDropList() {
    if (!dataCacheMap[this.type]) {
      dataCacheMap[this.type] = this.$get("/manager/link/list", {
        type: this.type,
        mode: this.mode,
      });
    }
    let { error, data } = await dataCacheMap[this.type];
    if (error) {
      delete dataCacheMap[this.type];
      return;
    }
    this.list = data;
  }


  // $prompt 返回的是 element-plus 的 MessageBoxData（{ value, action }），
  // 链接只存输入的内容；取消时返回 undefined，走“不改动”的分支。
  async promptLink(title, inputPlaceholder, inputValue = "") {
    try {
      let { value } = await this.$prompt('提示', { title, inputPlaceholder, inputValue });
      return value;
    } catch (e) {
      return undefined;
    }
  }

  isSameSelect(type, value) {
    let cur = this.modelValue || {};
    return cur.type == type && cur.value == value;
  }

  // el-cascader 对已经勾上的那一项不会再发 change（node.doCheck 里 checked 相同就直接 return），
  // 所以点回同一项时自己接一下，不然「自定义路径」这类二次点开不会再弹输入框
  nodeClick(node) {
    if (this.isSameSelect(node.pathValues[0], node.pathValues[1])) {
      this.changeEvent(node.pathValues);
    }
  }

  // 只改链接对象的这几个字段，其余（比如登录验证）保持不动
  emitLink(data) {
    this.$emit("update:modelValue", Object.assign({}, this.modelValue, data));
  }

  changeLogin(val) {
    this.emitLink({ login: val });
  }

  clearLink() {
    this.emitLink({ type: undefined, value: undefined, event: undefined, login: undefined });
  }

  async changeEvent(select) {
    this.key = Math.random();
    if (!select || !select.length) {
      return this.clearLink();
    }
    let [type, value] = select;
    // 点回同一项：弹窗里把上次填的值带上
    let same = this.isSameSelect(type, value);
    let item = this.getSelect({ type, value });
    let event;
    switch (item.event) {
      case "choosePage":
        event = await this.$choosePage({
          multiple: false,
        });
        if (event) {
          event = event[0].id;
        }
        break;
      case "chooseGoods":
        event = await this.$chooseGoods({
          multiple: false,
        });
        if (event) {
          event = event[0].id;
        }
        break;
      case "chooseGoodsCategory":
        event = await this.$chooseCategory({
          multiple: false,
        });
        if (event) {
          event = event[0].id;
        }
        break;
      case "chooseCase":
        event = await this.$chooseCase({
          multiple: false,
        });
        if (event) {
          event = event[0].id;
        }
        break;
      case "chooseCaseCategory":
        event = await this.$chooseCaseCategory({
          multiple: false,
        });
        if (event) {
          event = event[0].id;
        }
        break;
      case "chooseLink":
        event = await this.promptLink("请输入自定义链接", "如：https://", same ? this.linkEvent : "");
        break;
      case "choosePath":
        event = await this.promptLink("请输入自定义路径", "如： /pages/index/index", same ? this.linkEvent : "");
        break;
      case "chooseMini":
        event = await this.$chooseMiniLink({
          appidPlaceholder: "请输入小程序APPID",
          pagePlaceholder: "如： /pages/index/index",
          // 点回同一项时把上次填的带进去
          appid: same ? (this.linkEvent || {}).appid : "",
          page: same ? (this.linkEvent || {}).page : "",
        });
        break;
    }
    // 需要填内容的那一步被取消（弹窗没填就关掉）：整条选择保持原样。
    // 首页、购物车这些本来就没有 item.event，正常选中。
    if (item.event && !event) return;

    this.emitLink({ type, value, event });
  }

  getSelect(value) {
    for (let i = 0; i < this.list.length; i++) {
      let item = this.list[i];
      if (item.value == value.type) {
        if (!item.children) return item;
        for (let c = 0; c < item.children.length; c++) {
          let citem = item.children[c];
          if (citem.value == value.value) {
            return citem;
          }
        }
        return;
      }
    }
  }
  toggleSelect() {
    (this.$refs.cascader as any).togglePopperVisible();
  }
}


